export default __webpack_public_path__ + "images/DetallesMuestrasBesafer4.0-EN.png";